window.AddonState = {
  addons: new Map(),
  properties: new Map(), // Store both text and image data
  update() {
    document.dispatchEvent(new CustomEvent("addon:updated"))
  },
}

window.Splide = window.Splide || {}

class AbProductAddons extends HTMLElement {
  constructor() {
    super()
    this.mainSlider = null
    this.mainSliderElement = this.querySelector(".ab-product-addons-slider.splide")
    this.productPerRow = this.dataset.productPerRow
    this.layoutType = this.dataset.layoutType || "slider"
    this.activeTab = "all"
  }

  connectedCallback() {
    if (this.layoutType === "slider") {
      this.initSlider()
    }
    this.initTabs()
    this.addEventListener("click", this.handleClick.bind(this))
    this.addEventListener("input", this.handleInput.bind(this))
    document.addEventListener("addon:updated", this.updateUI.bind(this))
    this.updateUI()
    
    setTimeout(() => this.setupUploadcare())
  }
  initSlider() {
    if (!this.mainSliderElement) return

    this.mainAddonSlider = new window.Splide(this.mainSliderElement, {
      perPage: Number.parseInt(this.productPerRow) || 7,
      pagination: false,
      keyboard: true,
      clones: 0,
      perMove: 4,
      padding: { right: 15, left: 0 },
      gap: 10,
      breakpoints: {
        800: { perPage: 4, perMove: 3 },
        480: { perPage: 3, perMove: 2, gap: 3 },
      },
    }).mount()
  }

  initTabs() {
    this.querySelectorAll(".ab-addons-tabs__button").forEach((button) => {
      button.addEventListener("click", () => {
        this.querySelectorAll(".ab-addons-tabs__button").forEach((btn) => btn.classList.remove("is-active"))
        button.classList.add("is-active")
        this.activeTab = button.dataset.tab
        this.filterAddons()
      })
    })
  }

  filterAddons() {
    const active = this.activeTab.toLowerCase().trim()
    const cards =
      this.layoutType === "slider"
        ? this.querySelectorAll(".splide__slide .ab-addons-card")
        : this.querySelectorAll(".ab-addons-card")
    let visibleCount = 0

    cards.forEach((card) => {
      const rawTags = card.dataset.tags || ""
      const tags = rawTags.toLowerCase().split(/\s+/).filter(Boolean)
      const isVisible = active === "all" || tags.includes(active)

      const elementToHide = this.layoutType === "slider" ? card.closest(".splide__slide") : card

      if (isVisible) {
        elementToHide.classList.remove("ab-hidden")
        visibleCount++
      } else {
        elementToHide.classList.add("ab-hidden")
      }
    })

    if (this.layoutType === "slider" && this.mainAddonSlider) {
      this.mainAddonSlider.refresh()

      const perPage = this.mainAddonSlider.options.perPage || 4
      const arrowsContainer = this.querySelector(".splide__arrows")
      if (arrowsContainer) {
        if (visibleCount <= perPage) {
          arrowsContainer.style.display = "none"
        } else {
          arrowsContainer.style.display = ""
        }
      }
    }

    const container = this.querySelector(".ab-addons-container")
    let noMsg = container.querySelector(".ab-no-products")

    if (visibleCount === 0) {
      if (!noMsg) {
        noMsg = document.createElement("div")
        noMsg.className = "ab-no-products"
        noMsg.textContent = "No products available for this category."
        noMsg.style.cssText = "padding:20px;text-align:center;width:100%;grid-column:1/-1;"
        container.appendChild(noMsg)
      }
    } else {
      if (noMsg) noMsg.remove()
    }
  }

  handleClick(e) {
    const target = e.target
    const label = target.closest(".ab-addons-label")


    if (label && !target.closest(".ab-addons-qty-btn") && !target.matches(".ab-addons-qty-input")) {
      e.preventDefault()
      const checkbox = label.querySelector(".ab-addons-input")
      const qtyInput = label.querySelector(".ab-addons-qty-input")
      const variantId = Number.parseInt(qtyInput?.dataset.variantId)

      if (qtyInput) {
        checkbox.checked = !checkbox.checked
        label.classList.toggle("is-active", checkbox.checked)
        if (checkbox.checked) {
          window.AddonState.addons.set(variantId, Number.parseInt(qtyInput.value))
        } else {
          window.AddonState.addons.delete(variantId)
          window.AddonState.properties.delete(variantId)
          qtyInput.value = 1
        }
        window.AddonState.update()
      }
    } else if (target.closest(".ab-addons-qty-btn")) {
      e.preventDefault()
      e.stopPropagation()
      const btn = target.closest(".ab-addons-qty-btn")
      const input = btn.closest(".ab-addons-quantity-selector").querySelector(".ab-addons-qty-input")
      const variantId = Number.parseInt(input.dataset.variantId)
      const qty = Number.parseInt(input.value) + (btn.classList.contains("plus") ? 1 : -1)

      if (qty <= 0) {
        input.value = 1
        window.AddonState.addons.delete(variantId)
        window.AddonState.properties.delete(variantId)
        const label = btn.closest(".ab-addons-label")
        if (label) {
          label.querySelector(".ab-addons-input").checked = false
          label.classList.remove("is-active")
        }
        window.AddonState.update()
      } else {
        input.value = qty
        if (window.AddonState.addons.has(variantId)) {
          window.AddonState.addons.set(variantId, qty)
          window.AddonState.update()
        }
      }
    }
  }

  handleInput(e) {
    if (e.target.matches(".ab-addons-qty-input")) {
      const variantId = Number.parseInt(e.target.dataset.variantId)
      const qty = Math.max(1, Math.min(99, Number.parseInt(e.target.value) || 1))
      e.target.value = qty
      if (window.AddonState.addons.has(variantId)) {
        window.AddonState.addons.set(variantId, qty)
        window.AddonState.update()
      }
    }
    
    if (e.target.matches(".js-properties-input")) {
      const variantId = Number.parseInt(e.target.dataset.variantId)
      const value = e.target.value
      if (window.AddonState.addons.has(variantId)) {
        window.AddonState.properties.set(variantId, { type: 'text', value: value })
      }
    }
  }

  setupUploadcare() {
    if (typeof $ === 'undefined') {
      setTimeout(() => this.setupUploadcare(), 500)
      return
    }

    const self = this
    
    // Initialize uploader on all buttons immediately
    $('.ab-upload-btn').each(function() {
      const $btn = $(this)
      const variantId = $btn.data('variant-id')
      
      $btn.uploader({
        multi: false,
        onComplete: function(files) {
          if (files.length > 0) {
            const imageUrl = files[0].fileUrl
            
            // Store in state
            window.AddonState.properties.set(variantId, {
              type: 'image',
              value: imageUrl,
              filename: files[0].name || 'image.jpg'
            })
            
            // Show preview
            $(`.ab-personalized-file-container[data-variant-id="${variantId}"]`).hide()
            const $preview = $(`.ab-addons-image-preview-uploadcare[data-variant-id="${variantId}"]`)
            $preview.show()
            $preview.find('.ab-preview-link').attr('href', imageUrl)
            $preview.find('.polaroid-img-preview').attr('src', imageUrl)
          }
        }
      })
    })
    
    // Click preview to re-upload
    $(document).on('click', '.ab-addons-image-preview-uploadcare .ab-preview-link', function(e) {
      e.preventDefault()
      const variantId = $(this).closest('.ab-addons-image-preview-uploadcare').data('variant-id')
      $(`.ab-upload-btn[data-variant-id="${variantId}"]`).trigger('click')
    })
  }
 
  updateUI() {
    let hasCustomizableSelected = false

    this.querySelectorAll(".ab-addons-card").forEach((card) => {
      const variantId = Number.parseInt(card.dataset.variantId)
      const label = card.querySelector(".ab-addons-label")
      const checkbox = label.querySelector(".ab-addons-input")
      const qtyInput = label.querySelector(".ab-addons-qty-input")
      const isCustomizable = card.dataset.customizable === "true"

      if (window.AddonState.addons.has(variantId)) {
        checkbox.checked = true
        label.classList.add("is-active")
        if (qtyInput) qtyInput.value = window.AddonState.addons.get(variantId)
        if (isCustomizable) {
          hasCustomizableSelected = true
          this.toggleProperty(variantId, true)
        }
      } else {
        checkbox.checked = false
        label.classList.remove("is-active")
        if (qtyInput) qtyInput.value = 1
        if (isCustomizable) {
          this.toggleProperty(variantId, false)
        }
      }
    })

    const container = document.querySelector(".ab-addons-properties-container")
    if (container) {
      container.classList.toggle("is-show", hasCustomizableSelected)
    }
  }

  toggleProperty(variantId, show) {
    const section = document.querySelector(`.ab-addons-properties[data-variant-id="${variantId}"]`)
    if (!section) return

    const propertyType = section.dataset.propertyType
    const wasVisible = section.classList.contains("is-show")

    section.classList.toggle("is-show", show)

    if (show && !wasVisible) {
      setTimeout(() => section.scrollIntoView({ behavior: "smooth", block: "center" }), 350)
    } else if (!show) {
      if (propertyType === 'text') {
        const input = section.querySelector('.ab-addons-properties-input')
        if (input) input.value = ""
      } else if (propertyType === 'image') {
        // Hide preview, show upload button again
        $(`.ab-personalized-file-container[data-variant-id="${variantId}"]`).show()
        $(`.ab-addons-image-preview-uploadcare[data-variant-id="${variantId}"]`).hide()
      }
      window.AddonState.properties.delete(variantId)
    }
  }


}

customElements.define("ab-product-addons", AbProductAddons)